module.exports = __webpack_public_path__ + "static/media/highway-3392100_1920.ca111cfc.jpg";